import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

function DeleteLocationDialog({
  deleteLocationDialogOpen,
  setDeleteLocationDialogOpen,
  selectedLocation,
  deleteLocationLoading,
  handleConfirmDeleteLocation,
}) {
  return (
    <Dialog
      open={deleteLocationDialogOpen}
      onClose={() => setDeleteLocationDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ backgroundColor: "error.light", color: "white" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DeleteIcon />
          Confirm Deletion
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText>
          Are you sure you want to delete{" "}
          <strong>
            {selectedLocation?.name ? selectedLocation.name : "this location"}
          </strong>
          {""}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={() => setDeleteLocationDialogOpen(false)}
          variant="outlined"
          disabled={deleteLocationLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirmDeleteLocation}
          color="error"
          variant="contained"
          disabled={deleteLocationLoading}
        >
          {deleteLocationLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Delete"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteLocationDialog;
